import { LitElement, css, html } from 'lit';
export class FlensSlide extends LitElement {
	static properties = {
		active: { type: Boolean, reflect: true },
		clone: { type: Boolean, reflect: true },
	};

	static styles = css`
    :host {
      inline-size: 100%;
    }
  `;

	constructor() {
		super();
		this.active = false;
		this.clone = false;
	}

	render() {
		return html`<slot></slot>`;
	}
}

customElements.define('flens-slide', FlensSlide);
